// extracted by mini-css-extract-plugin
export default {"root":"menu_trigger___root___c1512c27","menu":"menu_trigger___menu___f352842c"};